<template>
    <div id="app">
        <!-- <el-alert
            v-if="isMoblie"
            class="moblie-tip"
            title="Please use a desktop or laptop browser to visit cmoffer.com for better experience."
            type="success"
            effect="dark"
        >
        </el-alert> -->
        <el-dialog
            :visible.sync="isMoblie"
            custom-class="login-mobile-notify"
            :lock-scroll="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            >
            <div>Only PC browser is supported.  Please copy the login link below to login with a Desktop or Laptop browser. </div>
            <div>Link: <el-link type="primary">{{rootUrl}}</el-link></div> <span slot="footer" class="dialog-footer">
                <el-button type="primary" ref="copyBtn" size="medium" @click="() => {
                    const el = $refs.copyBtn.$el
                    el.setAttribute('disabled', 'disabled')

                    copy(rootUrl, '', false);
                    el.textContent='Copied !'
                    win.setTimeout(() => {
                        el.textContent = 'Copy the Login Link'
                        el.removeAttribute('disabled')
                    }, 1200)
                }">Copy the Login Link</el-button>
                <div></div>
            </span>
        </el-dialog>
        <p>{{ calculatorScreenWidth }}</p>
        <router-view></router-view>
    </div>
</template>
<script>
import utils from "@/utils/util";
export default {
    data() {
        return {
            rootUrl: (() => {
                const { location } = window
                const { protocol, host } = location
                return `${protocol}//${host}/login`
            })(),
            isMoblie: utils.getOsType() == 2 ? false : true,
            win: window
        }
    },
    computed: {
    },
    methods: {
        getScreenResolution() {
            if (window.screen.width === 1600 && window.screen.height === 900) {
                this.$store.commit("SETSCREEN", "16x9");
            }
            window.onresize = () => {
                // this.screenResolution = document.body.offsetWidth;
                if (
                    window.screen.width === 1600 &&
                    window.screen.height === 900
                ) {
                    this.$store.commit("SETSCREEN", "16x9");
                }
            };
        },
    },
    created() {
        window.location.href.indexOf("cmoffer.loratech.cn") != -1 &&
            process.env.VUE_APP_MODE == "prod" &&
            (window.location.href = "https://app.cmoffer.com/");

    },
    mounted() {
        this.getScreenResolution();
    },
    watch: {
        $route: {
            handler(nv, ov) {
                const { path } = nv

                const menuList = JSON.parse(localStorage.getItem('menu_list'))

                if (menuList) for (let i = 0; i < menuList.length; i++) {
                    const { child, url, name } = menuList[i]
                    if (path === url) {
                        return (document.title = `CMOffer - ${name}`)
                    }

                    if (child) for (let j = 0; j < child.length; j++) {
                        const it = child[j]
                        if (path === it.url) {
                            return (document.title = `CMOffer - ${name} - ${it.name}`)
                        }

                        if (it.child) for (let k = 0; k < it.child.length; k++) {
                            const itc = it.child[k]
                            if (path === itc.url) {
                                return (document.title = `CMOffer - ${name} - ${it.name || it.category} - ${itc.name}`)
                            }
                        }
                    }
                }

                document.title = `CMOffer - ${nv.name.substring(0, 1).toUpperCase()}${nv.name.substring(1)}`
            }
        }
    }
};
</script>
<style lang="scss">
html,
body {
    width: 100%;
    height: 100%;
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100%;
        position: relative;
        .moblie-tip {
            position: fixed;
            left: 0;
            top: 0;
            z-index: 100;
        }

        .login-mobile-notify {
            width: 90%;
            padding: 20px 0;
            .el-dialog__header {
                display: none;
            }
            .el-dialog__body {
                font-size: 15px;
                line-height: 170%;
                word-break: break-word;

                >div:first-child {
                    text-align: left;
                }
                >div+div {
                    margin: 15px 0 8px 0;
                    .el-link {
                        font-size: 15px;
                    }
                }
            }
            .el-dialog__footer {
                .el-button {
                    font-size: 16px;
                    &[disabled] {
                        border-color: #8d89f9;
                        background-color: #8d89f9;
                    }
                }
            }

        }
    }
    #edui_fixedlayer {
        z-index: 9999 !important;
    }
    .el-table th.gutter {
        display: table-cell !important;
    }
}
</style>

